import React from 'react';

const LineIcon = ({ size = 20, color = "black" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <line x1="4" y1="12" x2="20" y2="12" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default LineIcon;
